

const About = () => {
  return (
    <div>
        <h1 className='text-4xl font-bold'>Documentation on API Access</h1>
        <h2 className='text-3xl font-bold py-5'>About Nature Photo Generator</h2>
        <p>You too can have random nature photos on your website! To access the api use the url: https://enthusiastic-crab-windbreaker.cyclic.app/api</p>
        <p className="py-5">If you like a specific photo you can access it by using: https://enthusiastic-crab-windbreaker.cyclic.app/api/number . Each photo has a corrisponding number displayed on the generating screen. </p>
        <p>I try and add new photos when I can so check back for new photos!</p>
        <h2 className='text-3xl font-bold py-5'>More Projects</h2>
        <p>For more of projects and work visit <a className="text-secondary" href="https://sashamarshalldesigns.netlify.app/">my website.</a></p>

    </div>
  )
}

export default About